module.exports = __webpack_public_path__ + "static/images/live-t2.2568ef4.png";